export const GASelectItem = () => {
  $(document).on("click", ".js_ga_select", function () {
    const p = $(this);
    const name = p.find(".title").text().trim();
    const parent = p.parent();
    const id = p.attr("data-sku");
    const price = parent.find(".price__current span").text();
    const dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "select_item",
      ecommerce: {
        items: [
          {
            item_name: name,
            item_id: id,
            price: price,
            quantity: 1,
          },
        ],
      },
    });
  });
};
